export const rugbyBundesligaRbaSitzungJanuar2026 = {
  "id": "rba-sitzung-januar-2026",
  "title": "RBA-Sitzung im Januar 2026: Richtungsentscheidungen zum Jahresauftakt der Rugby Bundesliga",
  "slug": "rba-sitzung-januar-2026",
  "publishedAt": "2026-01-21T12:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "8 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "RBA",
    "Saison 2025/26",
    "Ausbildungsbonus",
    "Durchführungsrichtlinie",
    "Videobeweis"
  ],
  "excerpt": "In der Sitzung des Rugby Bundesligaausschusses am 10. Januar 2026 wurden zentrale organisatorische und inhaltliche Entscheidungen für den weiteren Saisonverlauf und die strukturelle Entwicklung der Rugby Bundesliga getroffen.",
  "img": "/images/rba-sitzung-januar-2026.jpg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Die Rugby Bundesliga ist mit klaren organisatorischen und inhaltlichen Entscheidungen in das Jahr 2026 gestartet. In der Sitzung des Rugby Bundesligaausschusses am 10. Januar 2026 wurden zentrale Weichen für den weiteren Verlauf der Saison und für die strukturelle Weiterentwicklung des Bundesligabetriebs gestellt."
    },
    {
      "type": "paragraph",
      "content": "Die Sitzung war ursprünglich als Präsenzveranstaltung geplant, wurde jedoch aufgrund prognostizierter extremer Witterungsverhältnisse vollständig virtuell durchgeführt. Der Termin blieb bestehen und die digitale Durchführung stellte sicher, dass alle stimmberechtigten Vertreter gleichberechtigt teilnehmen konnten und die Tagesordnung vollständig behandelt wurde."
    },
    {
      "type": "paragraph",
      "content": "Im Tätigkeitsbericht wurde deutlich, dass der RBA seit der vorherigen Sitzung intensiv an der Organisation und Stabilisierung des Bundesligabetriebs gearbeitet hatte. Dazu zählten die laufende Betreuung des Spielbetriebs, die Vorbereitung der Finals 2026 sowie die Ausschreibung der Deutschen Meisterschaft im 15er Rugby, die in diesem Jahr in Ricklingen ausgetragen wird. Darüber hinaus wurden der Rahmenspielplan sowie die konkreten Spielpläne erstellt und koordiniert. Ein weiterer Schwerpunkt lag auf der Pflege der Ausbildungsbonustabellen und der Beratung der Bundesligisten in spielbetriebsrelevanten Fragen."
    },
    {
      "type": "paragraph",
      "content": "Parallel dazu wurden wichtige infrastrukturelle Themen vorangetrieben. Die neue Website der Rugby Bundesliga war online gegangen und sollte künftig als zentrale Informationsplattform dienen. Ergänzend führte der RBA Gespräche mit Anbietern von Videoaufnahmen, Sportevent Formaten und Marketingunternehmen. Der Einsatz des VEO Videotools wurde begleitet, die Social Media Arbeit ausgebaut und der Austausch mit Clubee intensiviert, unter anderem zur Verbesserung der Praktikabilität sowie zur Einführung zusätzlicher Funktionen im Bereich der Strafenerfassung."
    },
    {
      "type": "paragraph",
      "content": "Personell setzte der Ausschuss auf Kontinuität. Der amtierende Vorsitzende des Rugby Bundesligaausschusses, Branimir Niko Colic, wurde ebenso wiedergewählt wie der stellvertretende Vorsitzende für den 15er Spielbetrieb, Helmut Kraiger. Die Position des stellvertretenden Vorsitzenden für den 7er Spielbetrieb blieb unbesetzt. Gleichzeitig wurde beschlossen, dass diese Funktion bei Bedarf kommissarisch durch den Vorstand besetzt werden kann. Zudem wurde das Sportgericht personell ergänzt und damit die Grundlage für eine weiterhin funktionsfähige sportrechtliche Struktur geschaffen."
    },
    {
      "type": "paragraph",
      "content": "Den inhaltlichen Schwerpunkt der Sitzung bildeten mehrere Anträge zur Anpassung der Durchführungsrichtlinie der Rugby Bundesliga. Mit großer Mehrheit wurde beschlossen, den bisherigen Scorebonus künftig als Ausbildungsbonus zu bezeichnen. Diese Änderung stellte eine begriffliche Klarstellung dar und sollte den Förderzweck der Regelung deutlicher zum Ausdruck bringen."
    },
    {
      "type": "paragraph",
      "content": "Einstimmig angenommen wurde zudem die verpflichtende Dokumentation der Jugendlaufbahn für Spieler ab dem Geburtsjahrgang 2012. Ziel dieser Entscheidung war eine bundesweit einheitliche, transparente und rechtssichere Bewertung von Ausbildungsleistungen. Ergänzend beschloss der Ausschuss eine Erweiterung des Ausbildungszeitraums, um Ausbildungswege differenzierter und realistischer abbilden zu können."
    },
    {
      "type": "paragraph",
      "content": "Abgelehnt wurden hingegen die Anträge zur Einführung zusätzlicher Boni für langfristige Vereinszugehörigkeit sowie ehrenamtliches Engagement. In der Abwägung überwog die Einschätzung, dass das bestehende System dadurch zu stark aufgeweicht würde und seine klare Zielrichtung verlieren könnte."
    },
    {
      "type": "paragraph",
      "content": "Ein weiterer zentraler Beschluss betraf die Einführung eines Videobeweises im Rahmen eines Citing Verfahrens. Dieses wurde als Pilotprojekt beschlossen und beschränkte sich ausdrücklich auf die nachträgliche Bewertung von Tätlichkeiten in der Ersten und Zweiten Bundesliga. Andere Regelverstöße waren nicht Gegenstand dieser Regelung."
    },
    {
      "type": "paragraph",
      "content": "Unter dem Punkt Verschiedenes wurden unter anderem Themen wie Streaming, Trainersymposien und die Organisation der Finals angesprochen. Zudem wurden die Eckpunkte für die Qualifikation zur 7er Deutschen Meisterschaft bestätigt."
    },
    {
      "type": "paragraph",
      "content": "Abschließend wurde festgelegt, dass die nächste Sitzung des Rugby Bundesligaausschusses am 13. Juni 2026 stattfinden wird. Der Termin wurde bewusst in den Vorlauf zum Bundesliga Finale gelegt und soll in Hannover abgehalten werden. Damit sollte die Möglichkeit geschaffen werden, zentrale organisatorische Fragen in unmittelbarer Nähe zum sportlichen Saisonhöhepunkt zu beraten."
    },
    {
      "type": "paragraph",
      "content": "Mit der Sitzung im Januar 2026 verband die Rugby Bundesliga ihren kommunizierten Jahresauftakt mit konkreten und verbindlichen Entscheidungen. Die Beschlüsse stärkten die Ausbildungsorientierung, schufen mehr Klarheit in den Regelwerken und unterstrichen den Anspruch, den Bundesligabetrieb strukturell stabil, transparent und zukunftsfähig weiterzuentwickeln."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Sitzungs Protokolle jetzt online einsehen"
    },
    {
      "type": "paragraph",
      "content": "Die Protokolle der RBA-Sitzung sowie die entsprechenden Anträge sind ab sofort auf der Rugby Bundesliga Website verfügbar. Interessierte können die Dokumente herunterladen und sich detailliert über die besprochenen Themen und getroffenen Entscheidungen informieren."
    },
    {
      "type": "list",
      "items": [
        { "content": "Sitzungs-Protokolle", "url": "/ueber/downloads" }
      ]
    },
  ]
};

